'use client'
import AuthCard from '@/components/Auth/Card'
import { FormInput } from '@/components/Form/Input'
import { VStack } from '@/components/Layout/Stacks'
import ButtonLoading from '@/components/ui/button-loading'
import { useRouter } from '@/i18n/routing'
import { InternalApi } from '@/lib/api/internal-api'
import { useMutation } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'

export default function EnvironmentPasswordPage() {
  const router = useRouter()
  const { register, handleSubmit, formState } = useForm<{ password: string }>()

  const { mutate, isPending } = useMutation({
    mutationKey: ['environment-password'],
    mutationFn: ({ password }: { password: string }) =>
      InternalApi.post('/api/auth/environment-password', { password }),
    onSuccess: (data) => {
      if (data.status === 'Success') {
        toast.success('Success')
        router.replace('/')
      } else {
        toast.error('Error', {
          description: data.message,
        })
      }
    },
  })

  const onSubmit = async (data: { password: string }) => {
    mutate(data)
  }

  return (
    <form
      className="p-4 flex-1 flex justify-center  items-center"
      onSubmit={handleSubmit(onSubmit)}
    >
      <AuthCard title="Protected environment" description="Enter password">
        <VStack className="gap-4">
          <FormInput
            {...register('password', {
              required: {
                value: true,
                message: 'Password is required',
              },
            })}
            error={formState.errors.password}
            label="Password"
            type="password"
            placeholder="******"
          />
          <ButtonLoading
            isLoading={isPending}
            className="md:self-end"
            variant={'primary'}
            type="submit"
          >
            Submit
          </ButtonLoading>
        </VStack>
      </AuthCard>
    </form>
  )
}
